export const COLOR_WHITE = '#fff';
export const HOVER_WHITE = '#e6e8ed';
export const COLOR_NAVY = '#1f396c';
export const COLOR_PRODUCT_NAVY = '#d4dff4';
export const HOVER_NAVY = '#2f57a5';
export const HOVER_LIGHT_NAVY = '#bcd0f7';
export const COLOR_ORANGE = '#feaa47';
export const COLOR_RED = '#D99595';
export const COLOR_NAVY_BACKGROUND = '#e4eaf6';
export const COLOR_ORANGE_BACKGROUND_DARK = '#fce0c0';
export const COLOR_ORANGE_BACKGROUND_LIGHT = '#fff0df';
export const HOVER_ORANGE = '#feba6b';
export const HOVER_LIGHT_ORANGE = '#feeeda';
export const PLACEHOLDER_GREY = '#c5c5c5';
export const BACKGROUND_GREY = '#eeeeee';
export const DISABLED_GREY = '#f7f7f7';
export const LABEL_GREY = '#6b6b6b';
export const VALIDATION_RED = '#ff0000';
export const HOVER_GREY = 'rgba(153, 153, 153, 0.1)';
